import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { services } from "../mock";

export default function Services() {
  return (
    <section id="services" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">01 — Services</div>
            <h2 className="gt-serif text-4xl md:text-6xl max-w-3xl leading-[1.02]">
              Two disciplines. <span className="text-neutral-500">One outcome.</span>
            </h2>
          </div>
          <p className="max-w-md text-neutral-400">
            The Global Tribe stack is deliberately narrow — language that lands, and sales that
            close. Nothing in between.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {services.map((s) => (
            <article
              key={s.id}
              className="gt-hairline gt-hover-lift rounded-3xl p-8 md:p-10 bg-gradient-to-br from-white/[0.03] to-transparent relative overflow-hidden"
            >
              <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />
              <div className="flex items-center justify-between mb-6">
                <span className="px-3 py-1 text-[10px] tracking-[0.3em] rounded-full border border-emerald-400/40 text-emerald-400">
                  {s.tag}
                </span>
                <div className="text-right">
                  <div className="gt-serif text-3xl text-white">{s.metric}</div>
                  <div className="text-[11px] text-neutral-500 max-w-[160px]">{s.metricLabel}</div>
                </div>
              </div>

              <h3 className="gt-serif text-3xl md:text-4xl leading-tight text-white">{s.title}</h3>
              <div className="mt-3 text-emerald-400/90 text-sm tracking-wide">{s.kicker}</div>
              <p className="mt-5 text-neutral-400 leading-relaxed">{s.description}</p>

              <ul className="mt-8 space-y-3">
                {s.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-3 text-sm text-neutral-300">
                    <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-emerald-400/10 border border-emerald-400/40 flex items-center justify-center">
                      <Check className="w-3 h-3 text-emerald-400" />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className="mt-10 inline-flex items-center gap-2 text-sm text-white group"
              >
                <span className="border-b border-white/20 group-hover:border-emerald-400 pb-1 transition-colors">
                  Enroll / Book Discovery
                </span>
                <ArrowUpRight className="w-4 h-4 text-emerald-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
